import { render, staticRenderFns } from "./Menu5.vue?vue&type=template&id=60fb057d&"
import script from "./Menu5.vue?vue&type=script&lang=js&"
export * from "./Menu5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports